import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { PmcLogoComponent } from "@app/components/pmcLogo/pmcLogo.directive";
import { PropertySelectorComponent } from "@app/pages/wallet/landing/propertySelector.component";
import { HoaDetailsComponent } from "@app/pages/properties/hoadetails/hoadetails.component";
import { WalletLandingComponent } from "@app/pages/wallet/landing/walletlanding.component";
import { PropertyComponent } from "@app/components/property/property.directive";
import { PropertyLandingComponent } from "@app/pages/properties/landing/propertylanding.component";
import { PaymentScheduleComponent } from "@app/components/paymentSchedule/payment-schedule.component";
import { PaymentCancelComponent } from "@app/pages/payment/paymentcancel/paymentCancel.component";
import {
    PropertyLineItemDetailsComponent
} from "@app/components/propertyLineItemDetails/property-line-item-details.component";
import { CobrandHeader } from "@app/components/cobrandingHeader/cobrandHeader.directive";
import { PaymentHistoryComponent } from "@app/pages/properties/paymentHistory/paymentHistory.component";
import { PaymentHistoryDirectiveComponent } from "@app/components/paymentHistory/paymentHistory.directive";
import { CustomContentComponent } from "@app/components/misc/customContentDirective/customContent.directive";
import { PaymentComponent } from "@app/pages/payment/payment.component";
import { CreditCardAddComponent } from "@app/pages/wallet/cardadd/creditCardAdd.component";
import { CreditCardCheckoutAddComponent } from "@app/components/card/credit-card-add.component";
import { CardDetailAddComponent } from "@app/components/card/card-detail-add.component";
import { CardAddressComponent } from "@app/components/card/card-address.component";
import { CardNumberHostComponent } from "@app/components/card/card-number-host.component";
import { MonthYearSelectsComponent } from "@app/components/util/month-year-selects.component";
import { HeaderComponent } from "@app/components/header/header.component";
import { MenuComponent } from "@app/components/menu/menu.component";
import { MatDatePickerComponent } from "@app/components/material/matDatePicker/mat-date-picker.component";
import {
    DatePickerCustomHeaderComponent
} from "@app/components/material/matDatePicker/date-picker-custom-header.component";
import {
    SelectAmenitiesCartComponent,
    SelectAmenitiesComponent, SelectGuestAmenitiesComponent
} from "@app/components/selectAmenities/selectAmenities.directive";
import { AddressFormComponent, AddressFormEasyComponent } from "@app/components/addressForm/addressForm.directive";
import { PropertyFormLeftComponent } from "@app/components/propertyFormLeft/propertyFormLeft.directive";
import { ScheduleConfirmationComponent } from "@app/pages/payment/scheduleConfirmation/scheduleconfirmation.component";
import { ScheduleEditComponent } from "@app/pages/payment/scheduleEdit/scheduleEdit.component";
import { OneTimeEditComponent } from "@app/pages/payment/scheduleEdit/one-time-edit.component";
import {
    GuestAmenitiesPaymentSelectAmenitiesComponent
} from "@app/pages/guestpayment/guestAmenitiesPaymentSelectAmenities/guestAmenitiesPaymentSelectAmenities.component";
import { PaymentConfirmationComponent } from "@app/pages/payment/paymentconfirmation/paymentconfirmation.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "@app/app-routing.module";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PipesModule } from "@app/pipes/pipes.module";
import { SharedComponentModule } from "@app/components/shared.component.module";
import { MaterialModule } from "@app/components/material.module";
import { DirectivesModule } from "@app/components/directives.module";
import { DialogModule } from "@app/components/dialog.module";
import { ServicesModule } from "@app/services/services.module";
import { RegistrationComponent } from "@app/pages/registration/registration.component";
import { PersonalInfoComponent, PersonalInfoEasyComponent } from "@app/components/personalInfo/personalInfo.directive";
import { EmailComponent, EmailEasyComponent } from "@app/components/email/email.directive";
import { CreateAccountComponent } from "@app/pages/registration/createAccount.component";
import { RegistrationStep2Component } from "@app/pages/registration/registrationStep2.component";
import { PropertyDetailsComponent } from "@app/pages/properties/propertydetails/propertydetails.component";
import { SignupComponent } from "@app/pages/welcome/signup/signup.component";
import { MoreLandingComponent } from "@app/pages/more/landing/morelanding.component";
import { ViewCheckingAccountDetailsComponent } from "@app/pages/wallet/viewcheckdetails/viewCheckingAccountDetails.component";
import { PushPopFooterComponent } from "@app/components/pushpop/push.pop.footer.component";
import { CheckingAccountDetailsComponent } from "@app/pages/wallet/editcheckdetails/checkingAccountDetails.component";
import { CreditCardCheckoutEditComponent } from "@app/pages/wallet/cardedit/credit-card-edit.component";
import { EditCardDetailsComponent } from "@app/pages/wallet/editcarddetails/cardDetails.component";
import { CardDetailEditComponent } from "@app/components/card/card-detail-edit.component";
import { GuestPaymentComponent } from "@app/pages/guestpayment/guestpayment/guestpayment.component";
import { GuestPaymentCheckComponent } from "@app/pages/guestpayment/guestpaymentcheck/guestPaymentCheck.component";
import { GuestPaymentCardComponent } from "@app/pages/guestpayment/guestpaymentcard/guestPaymentCard.component";
import { GuestPaymentClear } from "@app/pages/guestpayment/guestpaymentclear/guestpaymentclear";
import { GuestPaymentRedirect } from "@app/pages/guestpayment/guestpaymentredirect/guestPaymentRedirect.component";
import { GuestPaymentConfirmationComponent } from "@app/pages/guestpayment/guestpaymentconfirmation/guestpaymentconfirmation.component";
import { GuestPaymentCancelComponent } from "@app/pages/guestpayment/guestpaymentcancel/guestPaymentCancel.component";
import { GuestPaymentSuccessComponent } from "@app/pages/guestpayment/guestpaymentsuccess/guestPaymentSuccess.component";
import { ViewCardDetailsComponent } from "@app/pages/wallet/viewcarddetails/viewCardDetails.component";
import { PasswordComponent } from "@app/components/password/password.directive";
import { PropertyInfoEasyComponent } from "@app/components/propertyInfo/propertyInfo.directive";
import { RegistrationEasyComponent } from "@app/pages/registration/easy/registrationEasy.component";
import { CreatePropertyGroupComponent } from "@app/pages/properties/propertygroup/createpropertygroup.component";
import { PropertyGroupDetailsComponent } from "@app/pages/properties/propertygroup/propertygroupdetails.component";
import {
    PropertyMultiRelationshipsComponent
} from "@app/pages/properties/propertygroup/propertyMultiRelationships.component";
import { CheckingAccountAddComponent } from "@app/pages/wallet/checkadd/checkingAccountAdd.component";
import { PaymentEditComponent } from "@app/pages/payment/paymentEdit/paymentEdit.component";
import { AddPropertyComponent } from "@app/pages/properties/addProperty/addProperty.component";
import { ScheduleViewComponent } from "@app/pages/payment/scheduleView/scheduleView.component";
import { PaymentSuccessComponent } from "@app/pages/payment/successpaymentconfirmation/paymentsuccess.component";
import { ScheduleEditDayComponent } from "@app/pages/payment/scheduleEdit/scheduleEditDay.component";
import { LoginComponent } from "@app/pages/welcome/login/login.component";
import { ApiServicesModule } from "@app/services/apiServices/api.services.module";
import { PayByMailComponent } from "@app/pages/welcome/paybymail/payByMail.component";
import { AlertsComponent } from "@app/pages/more/alerts/alerts.component";
import { CallbackComponent } from "@app/pages/callback/callback.component";
import { StartSsoLoginComponent } from "@app/sso/start-sso-login/start-sso-login.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ErrorDialogComponent } from "@app/components/error-dialog/error-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";
import {
    FuturePaymentConfirmationComponent
} from "@app/pages/payment/future-payment-confirmation/future-payment-confirmation.component";
import { MakeSsoDecisionComponent } from "@app/sso/make-sso-decision/make-sso-decision.component";
import { SearchSsoProfileComponent } from "@app/sso/search-sso-profile/search-sso-profile.component";
import { CreateSsoProfileComponent } from "@app/sso/create-sso-profile/create-sso-profile.component";
import { ExistingSsoProfileMergeComponent } from "@app/sso/existing-sso-profile-merge/existing-sso-profile-merge.component";
import { AlertBannerComponent } from "@app/shared/alert-banner/alert-banner.component";

@NgModule({
    declarations: [
        PmcLogoComponent,
        PropertySelectorComponent,
        HoaDetailsComponent,
        WalletLandingComponent,
        PropertyComponent,
        PropertyLandingComponent,
        PaymentScheduleComponent,
        PaymentCancelComponent,
        PropertyLineItemDetailsComponent,
        CobrandHeader,
        PaymentHistoryComponent,
        PaymentHistoryDirectiveComponent,
        CustomContentComponent,
        PaymentComponent,
        CreditCardAddComponent,
        CreditCardCheckoutAddComponent,
        CardDetailAddComponent,
        CardAddressComponent,
        CardNumberHostComponent,
        MonthYearSelectsComponent,
        HeaderComponent,
        MenuComponent,
        MatDatePickerComponent,
        DatePickerCustomHeaderComponent,
        SelectAmenitiesComponent,
        SelectAmenitiesCartComponent,
        AddressFormComponent,
        AddressFormEasyComponent,
        PropertyFormLeftComponent,
        ScheduleConfirmationComponent,
        ScheduleEditComponent,
        OneTimeEditComponent,
        SelectGuestAmenitiesComponent,
        GuestAmenitiesPaymentSelectAmenitiesComponent,
        PaymentConfirmationComponent,
        FuturePaymentConfirmationComponent,
        PersonalInfoEasyComponent,
        PersonalInfoComponent,
        PropertyDetailsComponent,
        EmailComponent,
        EmailEasyComponent,
        RegistrationComponent,
        RegistrationStep2Component,
        CreateAccountComponent,
        SignupComponent,
        MoreLandingComponent,
        StartSsoLoginComponent,
        MakeSsoDecisionComponent,
        CreateSsoProfileComponent,
        SearchSsoProfileComponent,
        ExistingSsoProfileMergeComponent,
        ViewCardDetailsComponent,
        PushPopFooterComponent,
        EditCardDetailsComponent,
        CreditCardCheckoutEditComponent,
        CardDetailEditComponent,
        CheckingAccountDetailsComponent,
        GuestPaymentComponent,
        GuestPaymentCheckComponent,
        GuestPaymentCardComponent,
        GuestPaymentClear,
        GuestPaymentRedirect,
        GuestPaymentConfirmationComponent,
        GuestPaymentCancelComponent,
        GuestPaymentSuccessComponent,
        ViewCheckingAccountDetailsComponent,
        PasswordComponent,
        PropertyInfoEasyComponent,
        RegistrationEasyComponent,
        CreatePropertyGroupComponent,
        PropertyGroupDetailsComponent,
        PropertyMultiRelationshipsComponent,
        CheckingAccountAddComponent,
        PaymentEditComponent,
        AddPropertyComponent,
        ScheduleViewComponent,
        PaymentSuccessComponent,
        ScheduleEditDayComponent,
        LoginComponent,
        PayByMailComponent,
        AlertsComponent,
        CallbackComponent,
        ErrorDialogComponent,
        AlertBannerComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        PipesModule,
        SharedComponentModule,
        MaterialModule,
        DirectivesModule,
        DialogModule,
        ServicesModule,
        ApiServicesModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        ReactiveFormsModule,
    ],
    exports: [HeaderComponent, PushPopFooterComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
